import { Patron } from "@/composables/patrons";
import { CategoryId } from "@/services/collection/categories";
import { gettext } from "@/services/translation";

export type LandingPageSetup = {
  categoryId: CategoryId;
  heroImage: { url: string; mime: string }[];
  heroText: string | undefined;
  itemsText: string;
  collectorsText: string;
  magazineText: string;
  patronsText: string;
  patrons: Patron[];
};

export const factoryLandingPageSetupLegoSets = (): LandingPageSetup => ({
  categoryId: CategoryId.LegoSets,
  heroImage: [
    { url: "/images/homepage/collage-lego-sets.webp", mime: "image/webp" },
    { url: "/images/homepage/collage-lego-sets.avif", mime: "image/avif" },
    { url: "/images/homepage/collage-lego-sets.png", mime: "image/png" },
  ],
  heroText: gettext.$gettext("LEGO"),
  itemsText: gettext.$gettext("Obchoduj s ostatními sběrateli na našem LEGO tržišti. Sbírej, prodávej a bav se."),
  collectorsText: gettext.$gettext("Prohlédni si portfolia ostatních sběratelů a&nbsp;objev, kdo má stejnou vášeň pro LEGO jako ty."),
  magazineText: gettext.$gettext("Sleduj náš magazín a&nbsp;objevuj novinky a&nbsp;tipy z&nbsp;LEGO světa."),
  patronsText: gettext.$gettext("Spolupráce s našimi sběrateli a influencery posouvá platformu Colectio na vyšší level, děkujeme."),
  patrons: [Patron.Saviory, Patron.HonzovyKostky, Patron.CernyRytir, Patron.Benda, Patron.Investyr, Patron.MikeLacroix],
});

export const factoryLandingPageSetupVinyls = (): LandingPageSetup => ({
  categoryId: CategoryId.VinylRecords,
  heroImage: [
    { url: "/images/homepage/collage-vinyls.webp", mime: "image/webp" }, //
    { url: "/images/homepage/collage-vinyls.avif", mime: "image/avif" },
    { url: "/images/homepage/collage-vinyls.png", mime: "image/png" },
  ],
  heroText: gettext.$gettext("vinyly"),
  itemsText: gettext.$gettext("Obchoduj s ostatními sběrateli na našem tržišti<br>s&nbsp;vinyly. Sbírej, prodávej a bav se."),
  collectorsText: gettext.$gettext("Prohlédni si portfolia ostatních sběratelů<br>a&nbsp;objev, kdo má stejnou vášeň pro vinyly jako ty."),
  magazineText: gettext.$gettext("Sleduj náš magazín a objevuj novinky a&nbsp;tipy<br>ze světa vinylů."),
  patronsText: gettext.$gettext("Spolupráce s našimi sběrateli a influencery posouvá platformu Colectio na vyšší level, děkujeme."),
  patrons: [Patron.Saviory, Patron.HonzovyKostky, Patron.Investyr, Patron.CernyRytir, Patron.Benda, Patron.MikeLacroix],
});

export const factoryLandingPageSetupBoardGames = (): LandingPageSetup => ({
  categoryId: CategoryId.BoardGames,
  heroImage: [
    { url: "/images/homepage/collage-boardgames.webp", mime: "image/webp" }, //
    { url: "/images/homepage/collage-boardgames.avif", mime: "image/avif" },
    { url: "/images/homepage/collage-boardgames.png", mime: "image/png" },
  ],
  heroText: gettext.$gettext("deskovky"),
  itemsText: gettext.$gettext("Obchoduj s ostatními sběrateli na našem tržišti<br>s&nbsp;deskovkami. Sbírej, prodávej a bav se."),
  collectorsText: gettext.$gettext("Prohlédni si portfolia ostatních sběratelů<br>a&nbsp;objev, kdo má stejnou vášeň pro deskovky jako ty."),
  magazineText: gettext.$gettext("Sleduj náš magazín a objevuj novinky a&nbsp;tipy<br>ze světa deskovek."),
  patronsText: gettext.$gettext("Spolupráce s našimi sběrateli a influencery posouvá platformu Colectio na vyšší level, děkujeme."),
  patrons: [Patron.PlanetaHer, Patron.CernyRytir, Patron.Saviory, Patron.HonzovyKostky, Patron.Benda, Patron.Investyr, Patron.MikeLacroix],
});

export const factoryLandingPageSetupSportsCards = (): LandingPageSetup => ({
  categoryId: CategoryId.SportsCards,
  heroImage: [
    { url: "/images/homepage/collage-sports-cards.webp", mime: "image/webp" }, //
    { url: "/images/homepage/collage-sports-cards.avif", mime: "image/avif" },
    { url: "/images/homepage/collage-sports-cards.png", mime: "image/png" },
  ],
  heroText: gettext.$gettext("sportovní karty"),
  itemsText: gettext.$gettext("Obchoduj s ostatními sběrateli na našem tržišti<br>se sportovními kartami. Sbírej, prodávej a bav se."),
  collectorsText: gettext.$gettext("Prohlédni si portfolia ostatních sběratelů a&nbsp;objev, kdo má stejnou vášeň pro sportovní karty jako ty."),
  magazineText: gettext.$gettext("Sleduj náš magazín a objevuj novinky a tipy<br>ze světa sportovních karet."),
  patronsText: gettext.$gettext("Spolupráce s našimi sběrateli a influencery posouvá<br>platformu Colectio na vyšší level, děkujeme."),
  patrons: [Patron.MikeLacroix, Patron.Benda, Patron.CernyRytir, Patron.Investyr, Patron.PlanetaHer, Patron.VlastimilSprta],
});
